export const SET_USER = "SET_USER";

export const AUTH_START = "AUTH_START";
export const AUTH_ERROR = "AUTH_ERROR";
